import TemplateSettings from '../templateSettings/templateSettings.model'

export const filterSelectedTemplates = (templates: TemplateSettings[], templateIds: number[]) => {
  return templates.filter(t => templateIds.includes(t.id!))
}

export const addProductToTemplateSettings = (
  templates: TemplateSettings[],
  productId: number,
  description: string
) => {
  return (
    templates &&
    templates.map(t => {
      const productExists = t.products?.filter(p => p.value === productId)
      if (productExists && productExists.length > 0) {
        // if product is already exists
        return t
      } else {
        return {
          ...t,
          products: t.products
            ? [
                ...t.products,
                {
                  value: productId,
                  label: description
                }
              ]
            : [
                {
                  value: productId,
                  label: description
                }
              ]
        }
      }
    })
  )
}

export const deleteProductFromTemplateSettings = (
  templates: TemplateSettings[],
  productId: number
) => {
  return (
    templates &&
    templates.map(t => {
      return {
        ...t,
        products: t.products?.filter(p => p.value != productId)
      }
    })
  )
}
